var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ButtonIconContextual',{attrs:{"data-testid":"toggle-button","label":_vm.computedToggleLabel,"icon":_vm.computedToggleIcon},nativeOn:{"click":function($event){return _vm.toggleClick.apply(null, arguments)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }